import React from 'react';
import { WhatsAppIcon } from './ui/IconComponents';

const LiveDemo: React.FC = () => {
    return (
        <a
            href="https://wa.me/2349131985866"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 bg-[#25D366] w-16 h-16 rounded-full shadow-lg flex items-center justify-center transition-all transform hover:scale-110 focus:outline-none z-50 animate-pulse-glow"
            aria-label="Chat on WhatsApp"
        >
            <WhatsAppIcon />
        </a>
    );
};

export default LiveDemo;